export type ColumnDisplayEntry = 'nowrap' | 'empty-only' | { clamp: 1 | 2 | 3; width?: number; empty?: boolean; fit?: boolean };
export type ColumnDisplay = ColumnDisplayEntry | ColumnDisplayEntry[];
export const COLUMN_DISPLAY_CONFIG: Record<string, ColumnDisplay> = {
  date: 'nowrap',
  reference: 'nowrap',
  ref_no: 'nowrap',
  invoice_no: 'nowrap',
  receipt_no: 'nowrap',
  voucher_no: 'nowrap',
  bill_no: 'nowrap',
  code: 'nowrap',
  status: 'nowrap',
  risk: 'nowrap',
  priority: 'nowrap',
  job: 'nowrap',
  amount: 'nowrap',
  total: 'nowrap',
  total_amount: 'nowrap',
  balance: 'nowrap',
  paid: 'nowrap',
  paid_amount: 'nowrap',
  due: 'nowrap',
  due_amount: 'nowrap',
  debit: 'nowrap',
  credit: 'nowrap',
  price: 'nowrap',
  workorder: 'nowrap',
  sub_category: 'empty-only',
  mollakReference: 'empty-only',
  reported_by: 'empty-only',
  suggestion: 'empty-only',
  net_amount: 'nowrap',
  gross_amount: 'nowrap',
  vat: 'nowrap',
  vat_amount: 'nowrap',
  tax: 'nowrap',
  tax_amount: 'nowrap',
  cover_period: 'nowrap',
  period: 'nowrap',
  expiry: 'nowrap',
  receipt: 'nowrap',
  excess: 'nowrap',
  age: 'nowrap',
  case_type: 'nowrap',
  phone: 'nowrap',
  mobile: 'nowrap',

  name: { clamp: 2 },
  full_name: { clamp: 2 },
  title: { clamp: 2 },
  subject: { clamp: 2 },
  company_name: { clamp: 2 },
  location: { clamp: 2 },
  email: { clamp: 2 },
  type: { clamp: 2 },
  category: { clamp: 2 },
  primary_email: 'nowrap',
  client_name: { clamp: 2 },
  client_email: { clamp: 2 },
  tenant_english_name: { clamp: 2 },
  unit: { clamp: 2 },
  unit_no: { clamp: 2 },
  unitCustomer: { clamp: 2 },
  vendor_ref: { clamp: 2 },
  vendor_reference: { clamp: 2 },
  vendorReference: { clamp: 2 },
  activities: { clamp: 1, width: 140 },
  community: { clamp: 2, empty: false },
  association: { clamp: 2, empty: false },
  association_id: { clamp: 2, empty: false },
  vendor_id: { clamp: 2 },
  city_id: { clamp: 2 },
  user_id: { clamp: 2 },
  provider_id: { clamp: 2 },
  role_id: { clamp: 2 },
  assignee: { clamp: 2 },
  assigned_to: { clamp: 2 },
  created_by: { clamp: 2 },
  initiated_by: { clamp: 2 },
  requested_by: { clamp: 2 },
  rejected_by: { clamp: 2 },
  currently_with: { clamp: 2 },
  vendor: { clamp: 2 },
  account: { clamp: 2, width: 260 },
  budget: { clamp: 2, width: 260 },
  notes: { clamp: 2 },
  contact_person: { clamp: 2 },
  purpose: { clamp: 2 },
  payee: { clamp: 2 },
  provider: { clamp: 2 },
  owner: { clamp: 2 },
  ownerName: { clamp: 2 },
  tenant_name: { clamp: 2 },
  utility: { clamp: 2 },
  scope: { clamp: 2 },
  user: { clamp: 2 },
  city: { clamp: 2 },
  country: { clamp: 2 },
  valuation_company: { clamp: 2 },
  insurance_company: { clamp: 2 },
  broker: { clamp: 2 },
  loss_adjuster: { clamp: 2 },
  reinstatement: { clamp: 2 },
  defendant: { clamp: 2 },
  survey_contact: { clamp: 2 },
  full_address: { clamp: 2 },
  description: { clamp: 2 },
  note: { clamp: 2 },
  memo: { clamp: 2 },
  comment: { clamp: 2 },
  comments: { clamp: 2 },
  remarks: { clamp: 2 },
  address: { clamp: 2 },
  log: { clamp: 2 },

  position: { clamp: 1 },
  asset_code: { clamp: 1 },
  reminder_cycle: { clamp: 1 },
};

export const NOWRAP_PATTERNS: RegExp[] = [
  /_at$/,
  /At$/,
  /date$/i,
  /_time$/,
  /_no$/,
  /_ref$/,
  /reference$/i,
  /_count$/,
  /^is_/,
  /^has_/,
  /^id$/,
  /status$/i,
  /period$/i,
  /expiry$/i,
  /number$/i,
  /phone$/i,
  /mobile$/i,
];

export const CLAMP_PATTERNS: RegExp[] = [/_name$/, /_by$/, /_email$/, /_company$/];
